export const IS_DEV = process.env.REACT_APP_ENVIRONMENT === 'development';
export const GOOGLE_KEY = process.env.REACT_APP_GOOGLE_KEY;
export const GOOGLE_MAP_ID = process.env.REACT_APP_GOOGLE_MAP_ID;

export const VALIDATION_CLASS = 'is-validation-error';

export const QUERY_PARAMS = {
  IS_DELETED: 'is_deleted',
  STEP: 'step',
  SKIP: 'skip',
  PAGE: 'page',
  LIMIT: 'limit',
  TARGET_DATE: 'target_date',
  MODE: 'mode',
  TZ: 'tz',
  SORT: 'sort',
  SUBSCRIPTION: 'subscription',
};

// мок данные для select, убрать после подключения к API
export const SENSOR_TYPES = [
  { value: 'sensecap_s2105', label: 'S2105' },
  { value: 'sensecap_s2108', label: 'S2108' },
  { value: 'sensecap_s2103', label: 'S2103' },
  { value: 'sensecap_s2102', label: 'S2102' },
  { value: 'sensecap_s2104', label: 'S2104' },
  { value: 'sensecap_s800', label: 'S800' },
];

export const FULL_GRAPH_AXIS_BY_SENSOR: Record<string, { min: number; max: number; step: number }> =
  {
    sensecap_s2105: { min: -30, max: 100, step: 10 },
    sensecap_s2108: { min: -30, max: 100, step: 10 },
    sensecap_s2103: { min: -40, max: 10000, step: 500 },
    sensecap_s2104: { min: -30, max: 100, step: 10 },
    sensecap_s800: { min: 0, max: 1250, step: 100 },
  };

export const OBJECT_SENSOR_TYPES = [
  {
    value: 'sensecap_s800',
    label: 'S800',
    displayLabel: 'S800 (Air Temp, Air Humid, Pressure, Wind Speed, Wind Dir, PM2.5, PM10, Noise)',
    searchLabel: 'S800 (Air Temp, Air Humid, Pressure, Wind Speed, Wind Dir, PM2.5, PM10, Noise)',
  },
  {
    value: 'sensecap_s2102',
    label: 'S2102',
    displayLabel: 'S2102 (Light Intensity)',
    searchLabel: 'S2102 (Light Intensity)',
  },
  {
    value: 'sensecap_s2103',
    label: 'S2103',
    displayLabel: 'S2103 (Air Temp, Air Humid, CO₂)',
    searchLabel: 'S2103 (Air Temp, Air Humid, CO₂)',
  },
];

export const ZONE_SENSOR_TYPES = [
  {
    value: 'sensecap_s2104',
    label: 'S2104',
    displayLabel: 'S2104 (Soil Temp, Soil Moisture)',
    searchLabel: 'S2104 (Soil Temp, Soil Moisture)',
  },
  {
    value: 'sensecap_s2105',
    label: 'S2105',
    displayLabel: 'S2105 (Soil Tempe, Soil Moisture, EC)',
    searchLabel: 'S2105 (Soil Tempe, Soil Moisture, EC)',
  },
  {
    value: 'sensecap_s2108',
    label: 'S2108',
    displayLabel: 'S2108 (Soil Tempe, Soil Moisture, EC, Pore Water EC, Epsilon)',
    searchLabel: 'S2108 (Soil Tempe, Soil Moisture, EC, Pore Water EC, Epsilon)',
  },
];

export const PLANT_TYPES = [
  { value: 'palm_tree', label: 'Palm Trees' },
  { value: 'shade_tree', label: 'Shade Trees' },
  { value: 'ornamental_tree', label: 'Ornamental Trees' },
  { value: 'bushes', label: 'Shrubs / Bushes' },
  { value: 'ground', label: 'Ground Cover' },
  { value: 'vertical_greenery', label: 'Climbing / Vertical Greenery' },
  { value: 'decorative_grasses', label: 'Decorative Grasses' },
  { value: 'succulents', label: 'Succulents / Xerophytes' },
  { value: 'seasonal_flowers', label: 'Seasonal Flowers' },
  { value: 'desert_plants', label: 'Native Desert Plants' },
];

export const PLANT_NAMES = [
  {
    value: 'phoenix_dactylifera',
    label: 'Date Palm (Phoenix dactylifera)',
    type: 'palm_tree',
  },
  {
    value: 'phoenix_canariensis',
    label: 'Canary Island Date Palm (Phoenix canariensis)',
    type: 'palm_tree',
  },
  {
    value: 'washingtonia_robusta',
    label: 'Washingtonia Palm (Washingtonia robusta)',
    type: 'palm_tree',
  },
  { value: 'bismarck_palm', label: 'Bismarck Palm', type: 'palm_tree' },
  {
    value: 'wodyetia_bifurcata',
    label: 'Foxtail Palm (Wodyetia bifurcata)',
    type: 'palm_tree',
  },
  {
    value: 'dypsis_lutescens',
    label: 'Areca Palm (Dypsis lutescens)',
    type: 'palm_tree',
  },
  {
    value: 'roystonea_regia',
    label: 'Royal Palm (Roystonea regia)',
    type: 'palm_tree',
  },
  {
    value: 'prosopis_cineraria',
    label: 'Ghaf Tree (Prosopis cineraria)',
    type: 'shade_tree',
  },
  {
    value: 'azadirachta_indica',
    label: 'Neem Tree (Azadirachta indica)',
    type: 'shade_tree',
  },
  {
    value: 'delonix_regia',
    label: 'Flame Tree (Delonix regia)',
    type: 'shade_tree',
  },
  {
    value: 'samanea_saman',
    label: 'Rain Tree (Samanea saman)',
    type: 'shade_tree',
  },
  {
    value: 'terminalia_catappa',
    label: 'Indian Almond (Terminalia catappa)',
    type: 'shade_tree',
  },
  {
    value: 'ficus_microcarpa',
    label: 'Ficus Nitida (Ficus microcarpa)',
    type: 'shade_tree',
  },
  {
    value: 'frangipani',
    label: 'Frangipani / Plumeria',
    type: 'ornamental_tree',
  },
  {
    value: 'brachychiton',
    label: 'Bottle Tree (Brachychiton)',
    type: 'ornamental_tree',
  },
  {
    value: 'orchid_tree',
    label: 'Bauhinia (Orchid Tree)',
    type: 'ornamental_tree',
  },
  { value: 'jacaranda', label: 'Jacaranda', type: 'ornamental_tree' },
  { value: 'tabebuia', label: 'Tabebuia', type: 'ornamental_tree' },
  { value: 'bougainvillea', label: 'Bougainvillea', type: 'bushes' },
  { value: 'hibiscus', label: 'Hibiscus', type: 'bushes' },
  { value: 'oleander', label: 'Oleander', type: 'bushes' },
  { value: 'duranta', label: 'Duranta', type: 'bushes' },
  { value: 'tecoma', label: 'Tecoma', type: 'bushes' },
  { value: 'ixora', label: 'Ixora', type: 'bushes' },
  { value: 'gardenia', label: 'Gardenia', type: 'bushes' },
  { value: 'lantana', label: 'Lantana', type: 'ground' },
  { value: 'wedelia', label: 'Wedelia', type: 'ground' },
  { value: 'vinca', label: 'Vinca', type: 'ground' },
  { value: 'gazania', label: 'Gazania', type: 'ground' },
  { value: 'portulaca', label: 'Portulaca', type: 'ground' },
  { value: 'carpobrotus', label: 'Carpobrotus', type: 'ground' },
  {
    value: 'bougainvillea_climbing',
    label: 'Bougainvillea (climbing)',
    type: 'vertical_greenery',
  },
  { value: 'jasmine', label: 'Jasmine', type: 'vertical_greenery' },
  { value: 'clerodendrum', label: 'Clerodendrum', type: 'vertical_greenery' },
  { value: 'passionflower', label: 'Passionflower', type: 'vertical_greenery' },
  { value: 'ivy', label: 'Ivy (shaded zones)', type: 'vertical_greenery' },
  {
    value: 'pennisetum',
    label: 'Fountain Grass (Pennisetum)',
    type: 'decorative_grasses',
  },
  {
    value: 'vetiver_grass',
    label: 'Vetiver Grass',
    type: 'decorative_grasses',
  },
  { value: 'miscanthus', label: 'Miscanthus', type: 'decorative_grasses' },
  { value: 'pampas_grass', label: 'Pampas Grass', type: 'decorative_grasses' },
  { value: 'aloe', label: 'Aloe', type: 'succulents' },
  { value: 'agave', label: 'Agave', type: 'succulents' },
  { value: 'euphorbia', label: 'Euphorbia', type: 'succulents' },
  { value: 'yucca', label: 'Yucca', type: 'succulents' },
  {
    value: 'cactus_urban_decorative',
    label: 'Cactus (urban decorative)',
    type: 'succulents',
  },
  { value: 'petunia', label: 'Petunia', type: 'seasonal_flowers' },
  { value: 'marigold', label: 'Marigold', type: 'seasonal_flowers' },
  { value: 'zinnia', label: 'Zinnia', type: 'seasonal_flowers' },
  { value: 'salvia', label: 'Salvia', type: 'seasonal_flowers' },
  { value: 'begonia', label: 'Begonia', type: 'seasonal_flowers' },
  { value: 'ghaf', label: 'Ghaf', type: 'desert_plants' },
  { value: 'calligonum', label: 'Arta (Calligonum)', type: 'desert_plants' },
  {
    value: 'adenium_obesum',
    label: 'Desert Rose (Adenium obesum)',
    type: 'desert_plants',
  },
  { value: 'acacia', label: 'Acacia', type: 'desert_plants' },
  { value: 'leptadenia', label: 'Leptadenia', type: 'desert_plants' },
];

export const SOIL_TYPE = [
  { value: 'municipal', label: 'Municipal landscaping soil' },
  { value: 'palm_mix', label: 'Palm soil mix' },
  { value: 'sandy_loam', label: 'Sandy loam' },
  { value: 'sandy', label: 'Sandy soil (desert)' },
  { value: 'compost', label: 'Soil with compost' },
  { value: 'leca', label: 'Soil with LECA / drainage layer' },
  { value: 'perlite', label: 'Soil with perlite' },
  { value: 'turf', label: 'Turf soil' },
  { value: 'urban_mixed', label: 'Urban mixed soil' },
  { value: 'xerophyte', label: 'Xerophyte soil' },
];

export const SensorMeasurement: {
  [key: string | number]: {
    label: string;
    color?: string;
    unit?: string;
    axisMin?: number;
    axisMax?: number;
    axisStep?: number;
  };
} = {
  4097: {
    label: 'Air Temperature',
    color: '#7866FF',
    unit: '℃',
    axisMin: -40,
    axisMax: 90,
    axisStep: 10,
  },
  4098: {
    label: 'Air Humidity',
    color: '#1EA9F7',
    unit: '% RH',
    axisMin: 0,
    axisMax: 100,
    axisStep: 10,
  },
  4099: {
    label: 'Light Intensity',
    color: '#F7D71E',
    unit: 'Lux',
    axisMin: 0,
    axisMax: 190000,
    axisStep: 10000,
  },
  4100: { label: 'CO2', color: '#F17AFC', unit: 'ppm', axisMin: 0, axisMax: 10000, axisStep: 500 },
  4101: {
    label: 'Barometric Pressure',
    color: '#8B5CF6',
    unit: 'hPa',
    axisMin: 300,
    axisMax: 1250,
    axisStep: 100,
  },
  4102: {
    label: 'Soil Temperature',
    color: '#37D50F',
    unit: '℃',
    axisMin: -30,
    axisMax: 70,
    axisStep: 10,
  },
  4103: {
    label: 'Soil Moisture',
    color: '#06B394',
    unit: '%',
    axisMin: 0,
    axisMax: 100,
    axisStep: 10,
  },
  4104: {
    label: 'Wind Direction',
    color: '#059669',
    unit: '°',
    axisMin: 0,
    axisMax: 360,
    axisStep: 45,
  },
  4105: {
    label: 'Wind Speed',
    color: '#0891B2',
    unit: 'm/s',
    axisMin: 0,
    axisMax: 80,
    axisStep: 10,
  },
  4106: { label: 'pH' },
  4107: { label: 'Light Quantum' },
  4108: {
    label: 'Electrical Conductivity',
    color: '#FF9432',
    unit: 'mS/cm',
    axisMin: 0,
    axisMax: 24,
    axisStep: 3,
  },
  4109: { label: 'Dissolved Oxygen' },
  4110: { label: 'Soil Volumetric Water Content' },
  4111: { label: 'Soil Electrical Conductivity' },
  4112: { label: 'Soil Temperature (Soil Temperature, VWC & EC Sensor)' },
  4113: { label: 'Rainfall Hourly' },
  4115: { label: 'Distance' },
  4116: { label: 'Water Leak' },
  4117: { label: 'Liquid Level' },
  4118: { label: 'NH3' },
  4119: { label: 'H2S' },
  4120: { label: 'Flow Rate' },
  4121: { label: 'Total Flow' },
  4122: { label: 'Oxygen Concentration' },
  4123: { label: 'Water Electrical Conductivity' },
  4124: { label: 'Water Temperature' },
  4125: { label: 'Soil Heat Flux' },
  4126: { label: 'Sunshine Duration' },
  4127: { label: 'Total Solar Radiation' },
  4128: { label: 'Water Surface Evaporation' },
  4129: { label: 'Photosynthetically Active Radiation (PAR)' },
  4130: { label: 'Accelerometer' },
  4131: { label: 'Sound Intensity' },
  4133: { label: 'Soil Tension' },
  4134: { label: 'Salinity' },
  4135: { label: 'TDS' },
  4136: { label: 'Leaf Temperature' },
  4137: { label: 'Leaf Wetness' },
  4138: { label: 'Soil Moisture - 10cm' },
  4139: { label: 'Soil Moisture - 20cm' },
  4140: { label: 'Soil Moisture - 30cm' },
  4141: { label: 'Soil Moisture - 40cm' },
  4142: { label: 'Soil Temperature - 10cm' },
  4143: { label: 'Soil Temperature - 20cm' },
  4144: { label: 'Soil Temperature - 30cm' },
  4145: { label: 'Soil Temperature - 40cm' },
  4146: {
    label: 'PM2.5',
    color: '#DC2626',
    unit: 'µg/m³',
    axisMin: 0,
    axisMax: 1000,
    axisStep: 100,
  },
  4147: {
    label: 'PM10',
    color: '#EA580C',
    unit: 'µg/m³',
    axisMin: 0,
    axisMax: 1000,
    axisStep: 100,
  },
  4148: { label: 'Noise', color: '#CA8A04', unit: 'dB', axisMin: 35, axisMax: 100, axisStep: 10 },
  4150: { label: 'Accelerometer X' },
  4151: { label: 'Accelerometer Y' },
  4152: { label: 'Accelerometer Z' },
  4154: { label: 'Salinity (PSU)' },
  4155: { label: 'ORP' },
  4156: { label: 'Turbidity' },
  4157: { label: 'Ammonia ion' },
  4158: { label: 'Electrical Conductivity - 10cm' },
  4159: { label: 'Electrical Conductivity - 20cm' },
  4160: {
    label: 'Electrical Conductivity - 30cm',
  },
  4161: {
    label: 'Electrical Conductivity - 40cm',
  },
  4162: {
    label: 'N Content',
  },
  4163: {
    label: 'P Content',
  },
  4164: {
    label: 'K Content',
  },
  4165: { label: 'Measurement 1' },
  4166: { label: 'Measurement 2' },
  4167: { label: 'Measurement 3' },
  4168: { label: 'Measurement 4' },
  4169: { label: 'Measurement 5' },
  4170: { label: 'Measurement 6' },
  4171: { label: 'Measurement 7' },
  4172: { label: 'Measurement 8' },
  4173: { label: 'Measurement 9' },
  4174: { label: 'Measurement 10' },
  4175: { label: 'AI Detection No.01' },
  4176: { label: 'AI Detection No.02' },
  4177: { label: 'AI Detection No.03' },
  4178: { label: 'AI Detection No.04' },
  4179: { label: 'AI Detection No.05' },
  4180: { label: 'AI Detection No.06' },
  4181: { label: 'AI Detection No.07' },
  4182: { label: 'AI Detection No.08' },
  4183: { label: 'AI Detection No.09' },
  4184: { label: 'AI Detection No.10' },
  4190: { label: 'UV Index' },
  4191: { label: 'Peak Wind Gust' },
  4192: { label: 'Sound Intensity (dB)' },
  4193: { label: 'Light Intensity (no unit)' },
  4195: { label: 'TVOC' },
  4196: { label: 'Soil moisture intensity' },
  4197: { label: 'Longitude' },
  4198: { label: 'Latitude' },
  4199: { label: 'Light' },
  4200: { label: 'SOS Event' },
  4201: { label: 'Ultraviolet Radiation' },
  4202: { label: 'Dew point temperature' },
  4203: { label: 'Temperature', color: '#7866FF', unit: '℃' },
  4204: {
    label: 'Soil Pore Water Electrical Conductivity',
    color: '#B88455',
    unit: 'mS/cm',
    axisMin: 0,
    axisMax: 24,
    axisStep: 3,
  },
  4205: { label: 'Epsilon', color: '#FF6060', unit: '', axisMin: 0, axisMax: 100, axisStep: 10 },
  4206: { label: 'VOC Index' },
  4207: { label: 'Noise (no unit)' },
  4208: { label: 'Custom event' },
  4209: { label: 'Motion Id' },
  4210: { label: 'Accelerometer X (mg)' },
  4211: { label: 'Accelerometer Y (mg)' },
  4212: { label: 'Accelerometer Z (mg)' },
  4213: { label: 'Rain Accumulation' },
  4214: { label: 'Soil Moisture - 50cm' },
  4215: { label: 'Soil Moisture - 60cm' },
  4216: { label: 'Soil Temperature - 50cm' },
  4217: { label: 'Soil Temperature - 60cm' },
  4218: { label: 'Electrical Conductivity - 50cm' },
  4219: { label: 'Electrical Conductivity - 60cm' },
  5001: { label: 'Wi-Fi MAC Address' },
  5002: { label: 'Bluetooth Beacon MAC Address' },
  5003: { label: 'Event list' },
  5004: { label: 'Event list' },
  5100: { label: 'Switch' },
};
